import { FieldArray } from 'react-final-form-arrays';
import classNames from 'classnames';
import { useCallback } from 'react';
import { useForm } from 'react-final-form';

import { CloseButton } from '../../../UIPackage/MainModule/components/CloseButton';
import { IGroupConditionForm } from '../interfaces/IGroupConditionForm';
import styles from './PassportGroupConditionTree.module.scss';

interface IPassportGroupConditionTreeProps {
  selectedCondition: string;
  setSelectedCondition: (value: string) => void;
}

export const PassportGroupConditionTree = ({
  selectedCondition,
  setSelectedCondition,
}: IPassportGroupConditionTreeProps) => {
  const form = useForm();
  const { remove } = form.mutators;

  const removeInclude = useCallback(
    (index: number) => {
      remove && remove('includes', index);
    },
    [remove],
  );

  const removeException = useCallback(
    (index: number) => {
      remove && remove('exceptions', index);
    },
    [remove],
  );

  return (
    <div className={styles.ContentNavigation}>
      <h2 className={styles.NavigationTitle}>Условия</h2>
      <FieldArray name="includes">
        {({ fields }) =>
          fields.map((itemName, index) => {
            const fieldValue: IGroupConditionForm = fields.value[index];

            return (
              <div
                key={itemName}
                className={classNames(styles.NavigationItem, {
                  [styles.NavigationItemActive]: selectedCondition === itemName,
                })}
              >
                <span onClick={() => setSelectedCondition(itemName)}>{fieldValue.name}</span>
                <CloseButton className={styles.CloseButton} onClick={() => removeInclude(index)} />
              </div>
            );
          })
        }
      </FieldArray>
      <h2 className={styles.NavigationTitle}>Исключения</h2>
      <FieldArray name="exceptions">
        {({ fields }) =>
          fields.map((itemName, index) => {
            const fieldValue: IGroupConditionForm = fields.value[index];

            return (
              <div
                key={itemName}
                className={classNames(styles.NavigationItem, {
                  [styles.NavigationItemActive]: selectedCondition === itemName,
                })}
              >
                <span onClick={() => setSelectedCondition(itemName)}>{fieldValue.name}</span>
                <CloseButton className={styles.CloseButton} onClick={() => removeException(index)} />
              </div>
            );
          })
        }
      </FieldArray>
    </div>
  );
};
